import { ToolOutputCard } from './ToolOutputCard';

export interface ToolGroupEntry {
  toolCallId: string;
  name: string;
  input: unknown;
  output?: string | undefined;
  running: boolean;
}

interface Props {
  tools: ToolGroupEntry[];
}

/**
 * Renders a run of consecutive tool calls as a single bordered block. Each row
 * inside is an individually expandable ToolOutputCard. Seams between rows are
 * flush so the block reads as one contiguous trace — matches v1's grouped ghost
 * trace pattern.
 */
export function ToolGroup({ tools }: Props) {
  if (tools.length === 0) return null;

  return (
    <div
      data-testid="tool-group"
      style={{
        border: '1px solid var(--border)',
        borderRadius: 6,
        background: 'var(--surface)',
        marginBottom: 10,
        overflow: 'hidden',
      }}
    >
      {tools.map((t, i) => {
        const position =
          tools.length === 1
            ? 'solo'
            : i === 0
              ? 'first'
              : i === tools.length - 1
                ? 'last'
                : 'middle';
        return (
          <ToolOutputCard
            key={t.toolCallId || `tool-${i}`}
            name={t.name}
            input={t.input}
            output={t.output}
            running={t.running}
            position={position}
          />
        );
      })}
    </div>
  );
}
